//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed } from "@nuxtjs/composition-api";
import MemberBenefitsBox from "~/themes/fiskarsMoominDefault/components/components/organisms/MemberBenefitsBox/MemberBenefitsBox.vue";
import {imagePlaceholderProduct} from "~/common";
export default {
  name: "MoominMemberBenefitsBox",
  components: {
    MemberBenefitsBox
  },
  props: {
    title: {
      type: String,
      default: 'Member Benefits (hardcoded)'
    },
    description: {
      type: [String, Object],
      default: '<ul ><li>hardcoded</li><li >Enjoy inspiring stories about our designers, collections, exciting collaborations and new items.</li><li >Enjoy member benefits like members only discounts and special events.</li><li >Invitations to exclusive</li></ul>'
    },
    image: {
      type: Object,
      default: () => {
        return {
          desktop: '/error/error.svg',
          mobile: '/error/error.svg'
        }
      }
    },
    registerlabel: {
      type: String,
      default: 'Need to create an account? (hardcoded)'
    },
    registerbuttontext: {
      type: String,
      default: 'Register (hardcoded)'
    },
    link: {
      type: String,
      default: '/registration-hardcoded'
    },
    background: {
      type: Object,
      default: () => {
        return {
          desktop: '/error/error.svg',
          mobile: '/error/error.svg'
        }
      }
    }
  },
  setup(props) {
    const backgroundColor = computed(() => props.background?.background?.selectionValues[0]?.key);
    const benefits = computed(() => props.description?.value);
    const returnImage = computed(() => {
      if(props.image) return props.image
      return {
        desktop: imagePlaceholderProduct,
        mobile: imagePlaceholderProduct
      }
    })

    return {
      backgroundColor,
      benefits,
      returnImage
    }
  }
}
